<template>
  <button :class="[buttonClass, { disabled: isDisabled }]" @click="handleClick" type="button">
    <span v-if="icon" class="button-icon">
      <img :src="icon" alt="Icon" />
    </span>
    <span v-if="iconClass && position =='left'" :class="`icon-Bistro-_${iconClass}`" class="icon-class"></span>
    {{ text }}
    <span v-if="iconClass && position =='right'" :class="`icon-Bistro-_${iconClass}`" class="icon-class"></span>
  </button>
</template>

<script>
export default {
  name: "ButtonBistro",
  props: {
    variant: {
      type: String,
      default: "solid-blue",
      validator: function (value) {
        const validVariants = [
        // return [
          "solid-blue",
          "solid-gray",
          "solid-gray-hover",
          "solid-light-gray",
          "solid-red",
          "solid-bright-red",
          "gradient-blue",
          "gradient-green",
          "gradient-gray",
          "gradient-red",
          "icon-only",
          "transparent",
          "solid-primary-blue",
          "blue-add-category",
          "border-line-red",
          "border-line-green",
          "border-line-blue",
          "button-action",
          "shadow",
          "thin-button",
          "disabled",
          "disabled-add-category"
        // ].includes(value);
        ]
        return value.split(" ").every((v) => validVariants.includes(v));

      },
    },
    text: {
      type: String,
    },
    icon: {
      type: String,
      default: "",
    },
    iconClass: {
      type: String,
      default: "",
    },
    position: {
      type: String,
      default: 'left',
    },

  },
  computed: {
    buttonClass() {
      return `button-bistro ${this.variant}`;
    },
    isDisabled() {
      return this.$pdv.getIsDisabled;
    },
  },
  methods: {
    handleClick() {
      if (this.isDisabled) return;
      this.$emit("handleClick");
    },
  },
};
</script>

<style lang="scss">
.button-bistro {
  padding: 0 16px;
  cursor: pointer;
  border: none;
  border-radius: 6px;
  color: $lightColorBg;
  display: inline-flex;
  align-items: center;
  height: 48px;
  font-size: 16px;
  transition: all 0.3s ease;
  min-width: 100px;
  white-space: nowrap;
  min-width: 100px; 
  max-width: 100%;  
  white-space: nowrap; 
  flex-shrink: 0; 
  justify-content: center;
  font-family: 'Rubik-Medium';

  &:active:not(.disabled) {
    transform: scale(0.97);
    transition: transform 0.05s ease;
  }

  .button-icon {
    margin-right: 6px;
  }
  .icon-class {
    font-size: 20px;
  }
  &.icon-only {
    background: transparent;
    height: 38px;
    padding: 0;
    min-width: 38px;
    justify-content: center;

    span {
      margin: 0;
    }
  }

  &.solid-blue {
    background-color: $solidBlue;
  }


  &.solid-red {
    background-color: $solidRed;
  }

  &.solid-bright-red {
    background-color: $solidRed;
    font-size: 14px;
  }

  &.solid-gray {
    background-color: $solidGray;
  }

  &.solid-gray-hover {
    background-color: $solidGrayHover;
  }

  &.solid-light-gray {
    background-color: $solidLightGray;
    border: 1px solid $solidGrayHover;
    color: $darkColorFont;
    font-weight: normal;
    text-transform: uppercase;
    font-size: 16px;
  }

  &.gradient-blue {
    background: $gradientBlue;
  }

  &.gradient-green {
    background: $gradientGreen;
  }

  &.gradient-red {
    background: $gradientRed;
  }

  &.gradient-gray {
    background: $gradientGray;
  }

  &.solid-primary-blue {
    background-color: $solidBlue;
    color: $solidWhite;
    font-size: 14px;
    @media (hover: hover) {
      &:hover {
        background-color: $solidBlueHover;
      }
    }
  }

  &.transparent {
    background-color: transparent;
    color: $solidBlue;
  }

  &.disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
  @media (hover: hover) {
    &.solid-gray:hover {
      background-color: $solidGrayHover;
    }
  }
  &.blue-add-category { 
    color: $solidBlue;
    border: 1px dashed $solidGrayHover;
    border-radius: 6px;         
    padding: 10px 20px;   
    margin: 10px auto;      
    cursor: pointer;
    width: 100%;

    @media (hover: hover) {
      &:hover {
        color: $solidBlueHover;
      }
    }
  }
  &.disabled-add-category {
    color: $solidGray;
    border: 1px dashed $solidGray;
    margin: 10px auto;      
    width: 100%;
    
  }
  &.border-line-red {
    color: $solidRed;
    border: 1px solid $solidRed;
    background-color: $solidWhite;
    font-size: 14px;
    @media (hover: hover) {
      &:hover {
        color: $solidRed;
        border: 1px solid $solidRedHover;
      }
    }
  }
  &.border-line-green {
    color: $greenColor;
    border: 1px solid $greenColor;
    background-color: $solidWhite;
    font-size: 14px;
    @media (hover: hover) {
      &:hover {
        color: #5f9837;
        border: 1px solid #5f9837;
      }
    }
  }
  &.border-line-blue {
    color: $solidBlue;
    border: 1px solid $solidBlue;
    background-color: $solidWhite;
    font-size: 14px;
  }
  &.button-action{
    color: black;
    border: none;
    background-color: $lightColorBg;
    @media (hover: hover) {
      &:hover {
        background-color: #fbfbfb;
      }
    }

    &:focus {
      background-color: #fbfbfb;
    }

  }

  &.shadow {
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  }

  &.thin-button {
    height: 40px;
    min-width: 180px;
  }
}
</style>
